import { PokemonType as PT } from "types/battle-engine/battle";

export const isEffectiveAgainst = (attackerType: PT, defenderType: PT) => {
  return effectiveAgainst[attackerType].includes(defenderType);
};

export const isInneffectiveAgainst = (attackerType: PT, defenderType: PT) => {
  return inneffectiveAgainst[attackerType].includes(defenderType);
};

export const isNoEffectOn = (attackerType: PT, defenderType: PT) => {
  return noEffectOn[attackerType].includes(defenderType);
};

export const getTypeEffectiveness = (attackerType: PT, defenderType: PT) => {
  if (isEffectiveAgainst(attackerType, defenderType)) return 1.5;
  if (isInneffectiveAgainst(attackerType, defenderType)) return 0.75;
  if (isNoEffectOn(attackerType, defenderType)) return 0.33;
  return 1;
};

const effectiveAgainst: Record<PT, PT[]> = {
  [PT.NORMAL]: [],
  [PT.FIRE]: [PT.GRASS, PT.ICE, PT.BUG, PT.STEEL],
  [PT.WATER]: [PT.FIRE, PT.GROUND, PT.ROCK],
  [PT.GRASS]: [PT.WATER, PT.ROCK, PT.GROUND],
  [PT.ELECTRIC]: [PT.WATER, PT.FLYING],
  [PT.ICE]: [PT.GRASS, PT.GROUND, PT.FLYING, PT.DRAGON],
  [PT.PSYCHIC]: [PT.FIGHTING, PT.POISON],
  [PT.FIGHTING]: [PT.ROCK, PT.NORMAL, PT.STEEL, PT.DARK, PT.STEEL],
  [PT.POISON]: [PT.GRASS, PT.FAIRY],
  [PT.GROUND]: [PT.FIRE, PT.ELECTRIC, PT.POISON, PT.ROCK, PT.STEEL],
  [PT.FLYING]: [PT.GRASS, PT.FIGHTING, PT.BUG],
  [PT.BUG]: [PT.GRASS, PT.PSYCHIC, PT.DARK],
  [PT.ROCK]: [PT.FIRE, PT.FLYING, PT.ICE, PT.BUG],
  [PT.GHOST]: [PT.PSYCHIC, PT.GHOST],
  [PT.DRAGON]: [PT.DRAGON],
  [PT.DARK]: [PT.PSYCHIC, PT.GHOST],
  [PT.STEEL]: [PT.ICE, PT.FAIRY, PT.ROCK],
  [PT.FAIRY]: [PT.FIGHTING, PT.DRAGON, PT.DARK],
};

const inneffectiveAgainst: Record<PT, PT[]> = {
  [PT.NORMAL]: [],
  [PT.FIRE]: [PT.FIRE, PT.WATER, PT.ROCK, PT.DRAGON],
  [PT.WATER]: [PT.WATER, PT.GRASS, PT.DRAGON],
  [PT.GRASS]: [
    PT.FIRE,
    PT.GRASS,
    PT.POISON,
    PT.FLYING,
    PT.BUG,
    PT.DRAGON,
    PT.STEEL,
  ],
  [PT.ELECTRIC]: [PT.ELECTRIC, PT.GRASS, PT.DRAGON],
  [PT.ICE]: [PT.FIRE, PT.WATER, PT.ICE, PT.STEEL],
  [PT.PSYCHIC]: [PT.PSYCHIC, PT.STEEL],
  [PT.FIGHTING]: [PT.POISON, PT.FLYING, PT.PSYCHIC, PT.BUG, PT.FAIRY],
  [PT.POISON]: [PT.POISON, PT.GROUND, PT.ROCK, PT.GHOST],
  [PT.GROUND]: [PT.GRASS, PT.BUG],
  [PT.FLYING]: [PT.ELECTRIC, PT.ROCK, PT.STEEL],
  [PT.BUG]: [
    PT.FIRE,
    PT.FIGHTING,
    PT.POISON,
    PT.FLYING,
    PT.GHOST,
    PT.STEEL,
    PT.FAIRY,
  ],
  [PT.ROCK]: [PT.FIGHTING, PT.GRASS, PT.STEEL],
  [PT.GHOST]: [PT.DARK],
  [PT.DRAGON]: [PT.STEEL],
  [PT.DARK]: [PT.FIGHTING, PT.DARK, PT.FAIRY],
  [PT.STEEL]: [PT.FIRE, PT.WATER, PT.ELECTRIC, PT.STEEL],
  [PT.FAIRY]: [PT.FIRE, PT.POISON, PT.STEEL],
};

const noEffectOn: Record<PT, PT[]> = {
  [PT.NORMAL]: [PT.GHOST],
  [PT.FIRE]: [],
  [PT.WATER]: [],
  [PT.GRASS]: [],
  [PT.ELECTRIC]: [PT.GROUND],
  [PT.ICE]: [],
  [PT.PSYCHIC]: [PT.DARK],
  [PT.FIGHTING]: [PT.GHOST],
  [PT.POISON]: [PT.STEEL],
  [PT.GROUND]: [PT.FLYING],
  [PT.FLYING]: [],
  [PT.BUG]: [],
  [PT.ROCK]: [],
  [PT.GHOST]: [PT.NORMAL],
  [PT.DRAGON]: [PT.FAIRY],
  [PT.DARK]: [],
  [PT.STEEL]: [],
  [PT.FAIRY]: [],
};
